export const ROLES = {
  ADM: 'ADM', // Administrator
  ADM_DEV: 'ADM.DEV', // Developer
  BUN: 'BUN', // Bunkering
  CRMGR: 'CRMGR', // Crew Manager
  DPA: 'DPA', // DPA
  ESMS_EDITOR: 'ESMS.Editor', // ESMS Editor
  ESMS_READER: 'ESMS.Reader', // ESMS Reader
  EVN: 'EVN', // Events
  FRE: 'FRE', // Post Fixture
  FRM_RA_ADMIN: 'FRM.RA.Admin', // Risk Form Administrator
  HSQE_S: 'HSQE-S', // HSQE Superintendent
  INSP: 'INSP', // Inspections
  ITMGR: 'ITMGR', // IT Manager
  MAP_ADMIN: 'MAP.ADMIN', // MAP Admin
  MAP_CREW: 'MAP.CREW', // MAP Crew
  MAPVIEW: 'MAPVIEW', // Map Viewer
  MGM: 'MGM', // Management
  MGR: 'MGR', // Manager
  OFFICE: 'OFFICE', // Office User
  OPMGRD: 'OPMGRD', // Operations Manager Dry
  OPMGRT: 'OPMGRT', // Operations Manager Tanker
  PSMGR: 'PSMGR', // Planning & Strategy Manager
  PUMGR: 'PUMGR', // Purchasing Manager
  Q_EDITOR: 'Q.EDITOR', // Questionnaire Editor
  SEAMAN: 'SEAMAN', // Seaman
  TCE_APPROVERS: 'TCE.Approvers', // TCE Approvers
  TECH_S: 'TECH-S', // Technical Superintendent
  TEMGR: 'TEMGR', // Technical Manager
  USER: 'USER', // Simple User
  VESED: 'VESED', // Vessel Editor
  ASTRA_ESMS_APPROVERS: 'ASTRA.ESMS.Approvers', // ASTRA ESMS Approvers
  ASTRA_ESMS_EDITORS: 'ASTRA.ESMS.Editors', // ASTRA ESMS Editors
  ASTRA_ESMS_PUBLISHERS: 'ASTRA.ESMS.Publishers', // ASTRA ESMS Publishers
  ASTRA_NOON_EDITOR: 'ASTRA.NoonEditor', // ASTRA Noon Editor
  ASTRA_NOON_OWNER: 'ASTRA.NoonOwner', // ASTRA Noon Owner
  ACC_JUNIOR: 'ACC.JUNIOR', // Junior Accountant
  ACC_SENIOR: 'ACC.SENIOR', // Senior Accountant
  PMS_ADMIN: 'PMS.ADMIN', // PMS Administrator
  PUR_ADMIN: 'PUR.ADMIN', // PUR Administrator,
  PMS_ADMIN_TECHNICAL: 'PMS.ADMIN.TECHNICAL' // PMS: Main Libraries
} as const;

export type RoleCode = (typeof ROLES)[keyof typeof ROLES];

export const DELETED_VIEW_ROLES: RoleCode[] = [ROLES.ADM, ROLES.ADM_DEV, ROLES.TEMGR, ROLES.TECH_S];
